export default __webpack_public_path__ + "static/media/koleos-large.fcb40a72.jpg";